module.exports = __webpack_public_path__ + "img/ec.a5cccb8d.svg";